export async function dataUriToBlob(dataUri: string): Promise<Blob> {
  return await fetch(dataUri).then(res => res.blob());
}
